
<template>
    <div class="h-screen flex w-full bg-img">
        <div class="vx-col w-4/5 sm:w-4/5 md:w-3/5 lg:w-3/4 xl:w-3/5 mx-auto self-center">
            <vx-card>
                <div slot="no-body" class="full-page-bg-color">
                  <form  data-vv-scope="addEmailScope">
                    <div class="flex flex-wrap">
                        <div class="lg:block lg:w-1/2 md:w-full mx-auto self-center">
                            <img src="@/assets/images/logo/web-logo.png" alt="login" style="width:80%; max-height: 270px; object-fit: contain;"  class="mx-auto">
                        </div>

                        <div class="md:w-full lg:w-1/2 mx-auto self-center d-theme-dark-bg">
                            <div class="p-8">
                                <div class="vx-card__title mb-8">
                                    <h4 class="mb-4">School Admin</h4>
                                    <p>Please enter your email address and we'll send you instructions on how to reset your password.</p>
                                </div>

                                <vs-input
                                type="email"
                                v-validate="'required|email|min:3'"
                                data-vv-validate-on="blur"
                                data-vv-name="email"
                                name="email"
                                label-placeholder="Email"
                                v-model="email"
                                class="w-full mb-8" />
                                 <div v-if="errors.has('addEmailScope.email')"
                                style="color:red;"
                                class="invalid-feedback">{{ errors.first('addEmailScope.email') }}</div>
                                <br>
                                <vs-button type="border" to="/pages/login" class="px-4 w-full md:w-auto">Back To Login</vs-button>
                                <vs-button
                                @click="submitEmail"
                                 class="float-right px-4 w-full md:w-auto mt-3 mb-8 md:mt-0 md:mb-0">Reset Password
                                 </vs-button>

                            </div>
                        </div>

                    </div>
                  </form>
                </div>
            </vx-card>
        </div>
    </div>
</template>

<script>
import {ForgotPassword} from '@/api/login'
export default {
  data () {
    return {
      email: ''
    }
  },
  methods : {
    submitEmail () {
      this.$validator.validateAll('addEmailScope').then(valid => {
        if (valid) {
          const payload = {
            email: this.email
          }
          const data = ForgotPassword(payload)
          this.$vs.notify({
            title: 'Success',
            text: 'Email sent successfully',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'success'
          })
          // this.$router.push({name: 'password-setup', params: { 'email': this.email }})
        } else {
          this.$vs.notify({
            title: 'Waring',
            text: 'Email validation is required',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'warning'
          })
        }
      })
    }
  }
}
</script>
